/**
 * Created by Mark on 17/04/2017.
 */


import React  from 'react';

export default class ListItem extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            title : props.title || '',
            image : props.image || '',
        }
    }

    handleEmailChange(e) {
        this.setState({ email: e.target.value });
    }

    renderBadges(){
        return <span className="badge">14</span>;
    }

    render(){
        return (<li className="list-group-item">
            <span className=""><img className="avatar-img" src={this.state.image} alt=""/></span>
            <span className="p-l-5">{this.state.title}</span>
        </li>)
    }
}


// WEBPACK FOOTER //
// ./src/components/lists/list-item.js